module.exports = __webpack_public_path__ + "static/media/40.d1e674eb.mp4";